import { FormControlLabel, IconButton, Popover, Button, Checkbox, TextField } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { useState } from 'react';
import { EditionListStyle } from '../../styles/EditionListStyle';
// import NewLineProducts from './NewLineProducts';
// import { Button } from 'aws-amplify-react';
import AddIcon from '@material-ui/icons/Add';
import NewLineEdition from './NewLineEdition';
import Utils from '@/common/utils/utils';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import { reorder } from '../../handler/ProductManagementHandler';
import { checkOpenDropDownVerson, handleInputBlur, isEmptyListVersion, onChangeValue, onClickChangeStatus, onClickDeleteEditionItem, onClickToggleDropDownVersion, onEditModeEdition } from '../../handler/EditionListHandler';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import VersionList from './VersionList';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import UnCheckTrialIcon from './UnCheckTrialIcon';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import I18n from '@/rI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

const ListItemEdition = ({
    editionList,
    setEditionList,
    setHasError,
    onOpenVersionList,
    hasError,
    setIsEdit,
    openDropDownVersion,
    setOpenDropDownVersion,
    nameProduct,
    setListVersionUpdated,
    setOrderItem,
    listGptModel
}) => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const [anchorEl, setAnchorEl] = useState(null);
    const [popoverId, setPopoverId] = useState();
    const [showPopUpDelete, setShowPopUpDelete] = useState({isOpen: false});
    const [listStatusEditionDisabled, setListStatusEditionDisabled] = useState([]);

    const classes = EditionListStyle();
    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const newItems = reorder(
            editionList,
            result.source.index,
            result.destination.index
        );

        // Update the 'order' field for each item based on their new position
        const updatedItems = newItems.map((item, index) => {
            let newOrder = newItems.length - (index +1);

            if (item.order !== newOrder) {
                item.isPositionChanged = true;
            }
            
            return {
            ...item,
            order: newItems.length - (index +1),
        }
        });
        setIsEdit(true);
        setEditionList(updatedItems);
    };

    const handleClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setPopoverId(id);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);

    const onClickHandler = (e, indexEdition) => {
        let checked = e.target.checked;
        setIsEdit(true);
        setEditionList(prevState => {
            const checkedItem = [...prevState];

            let indexCurrentChecked = checkedItem.findIndex((item, i) => {
                return item.isTrial === true;
            });

            if(indexCurrentChecked !== -1) {
                checkedItem[indexCurrentChecked] = {
                    ...checkedItem[indexCurrentChecked],
                    isTrial: false,
                    isUpdatedTrial: true
                };
            }

            checkedItem[indexEdition] = {
                ...checkedItem[indexEdition],
                isTrial: checked,
                isUpdatedTrial: true
            };
            return checkedItem;
        });
    }

    const getStatusItem = (item, onClick) => {
        if (Utils.isEmptyObject(item)) return null;
        let disabled = false;

        if(listStatusEditionDisabled.includes(item.id)) {
            disabled = true;
        }

        if (item.status === ProductManagementConstant.STATUS.ON_SALES) {
            return (
                <div
                    className="name-prod-status"
                    onClick={event =>onClick(event, item.id)}
                >
                    {trI18n('CM-DROPDOWN-ON_SALE')}
                </div>
            );
        }

        return (
            <div
                className={`name-prod-status status-inactive-sales ${disabled && 'status-inactive-sales-disabled'}`}
                onClick={event => !disabled && onClick(event, item.id)}
            >
                {trI18n('CM-DROPDOWN-INACTIVE-SALE')}
            </div>
        );
    };

    const renderLineCreateOrList = (provided, snapshot, edition, index) => {
        if (edition.createNewLine) {
            return (
                <NewLineEdition
                    edition={edition}
                    indexEdition={index}
                    provided={provided}
                    snapshot={snapshot}
                    setHasError={setHasError}
                    setEditionList={setEditionList}
                    hasError={hasError}
                    setIsEdit={setIsEdit}
                    setOrderItem={setOrderItem}
                />
            );
        }

        if(edition.isDeleted) {
            return  <div
                        className={`item-edition ${snapshot.isDragging ? 'dragging' : ''} ${
                            classes.itemEdition
                        }`}
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
            </div>;
        }

        return (
            <div
                className={`item-edition ${snapshot.isDragging ? 'dragging' : ''} ${
                    classes.itemEdition
                }`}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
            >
                <div className="edition-dragging">
                    <div key={edition.id} className="edition-content-row">
                        <div className="edition-content-trial">
                            <FormControlLabel
                                className="tag-item custom-radio"
                                control={
                                    <Checkbox
                                        disabled={
                                            edition.status ===
                                            ProductManagementConstant.STATUS.INACTIVE
                                        }
                                        onChange={e => {
                                            onClickHandler(e, index);
                                        }}
                                        value={edition.isTrial}
                                        checked={edition.isTrial}
                                        icon={
                                            <UnCheckTrialIcon
                                                isDiabled={
                                                    edition.status ===
                                                    ProductManagementConstant.STATUS.INACTIVE
                                                }
                                            />
                                        }
                                    />
                                }
                            />
                        </div>
                        <div className="edition-content-name">
                            {edition.modeEditing ? (
                                <TextField
                                    variant="outlined"
                                    className="input-add-newline-edition"
                                    value={edition.name}
                                    onChange={e =>
                                        onChangeValue(
                                            e,
                                            setEditionList,
                                            index,
                                            setHasError,
                                            setIsEdit
                                        )
                                    }
                                    onBlur={e =>
                                        handleInputBlur(setEditionList, index, setHasError)
                                    }
                                    error={!Utils.isEmptyString(edition?.error)}
                                    helperText={tr(I18n.get(edition.error)?.replace('{{maxLength}}', ProductManagementConstant.MAX_LENGTH_NAME))}
                                />
                            ) : (
                                <OverFlowTooltipWithTabsMui
                                    value={edition.name}
                                    className={classes.tableCellItemProduct}
                                />
                            )}
                        </div>
                        <div className="edition-content-status">
                            <div className="edition-value-status">
                                {getStatusItem(edition, handleClick)}
                                <Popover
                                    id={open ? 'status-popover' : undefined}
                                    open={open && popoverId === edition.id}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center'
                                    }}
                                >
                                    <ul className="list-status-sale">
                                        <li
                                            className="item-status-selected"
                                            onClick={() =>
                                                onClickChangeStatus(
                                                    setEditionList,
                                                    index,
                                                    ProductManagementConstant.STATUS.ON_SALES,
                                                    edition.status,
                                                    handleClose,
                                                    setIsEdit
                                                )
                                            }
                                        >
                                            <span className="status-onsales">
                                                {trI18n('CM-DROPDOWN-ON_SALE')}
                                            </span>
                                        </li>
                                        <li
                                            className="item-status-selected"
                                            onClick={() =>
                                                onClickChangeStatus(
                                                    setEditionList,
                                                    index,
                                                    ProductManagementConstant.STATUS.INACTIVE,
                                                    edition.status,
                                                    handleClose,
                                                    setIsEdit
                                                )
                                            }
                                        >
                                            <span className="status-inactive-sales">
                                                {trI18n('CM-DROPDOWN-INACTIVE-SALE')}
                                            </span>
                                        </li>
                                    </ul>
                                </Popover>
                            </div>
                            <div className="more-action">
                                <IconButton
                                    onClick={event =>
                                        handleClick(event, `more-action-${edition.id}`)
                                    }
                                    className="button-more"
                                >
                                    <img src="/assets/image/icon-nav-manage.svg" alt="" />
                                </IconButton>
                                <Popover
                                    id={open ? 'more-action-popover' : undefined}
                                    open={open && popoverId === `more-action-${edition.id}`}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right'
                                    }}
                                >
                                    <ul>
                                        <li
                                            className="more-action-item-edition"
                                            onClick={() =>
                                                onEditModeEdition(
                                                    edition.id,
                                                    setEditionList,
                                                    handleClose
                                                )
                                            }
                                        >
                                            <span className="item">
                                                <img src="/assets/image/edit-icon.svg" alt="" />
                                            </span>
                                            <span className="text">{trI18n('USER01BTN007')}</span>
                                        </li>
                                        {edition.status ===
                                            ProductManagementConstant.STATUS.INACTIVE && (
                                            <li
                                                className="more-action-item-edition"
                                                onClick={() => {
                                                    setShowPopUpDelete({
                                                        isOpen: true,
                                                        index: index
                                                    });
                                                    handleClose();
                                                }}
                                            >
                                                <span className="item">
                                                    <img
                                                        src="/assets/image/icon-tabs-delete.svg"
                                                        alt=""
                                                    />
                                                </span>
                                                <span className="text">
                                                    {trI18n('USER01LB006')}
                                                </span>
                                            </li>
                                        )}
                                    </ul>
                                </Popover>
                                <span
                                    className={`item-version ${
                                        isEmptyListVersion(edition.listVersion)
                                            ? 'icon-collapse-disabled'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        onClickToggleDropDownVersion(
                                            edition.id,
                                            setOpenDropDownVersion,
                                            edition.listVersion
                                        )
                                    }
                                >
                                    {checkOpenDropDownVerson(edition.id, openDropDownVersion) ? (
                                        <img src="/assets/image/icon-view-version-up.svg" alt="" />
                                    ) : (
                                        <img
                                            src="/assets/image/icon-view-version-down.svg"
                                            alt=""
                                        />
                                    )}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="show-list-title">
                            <Button
                                variant="text"
                                startIcon={<AddIcon />}
                                className={classes.buttonShowVersionLine}
                                onClick={() =>
                                    onOpenVersionList(
                                        {
                                            editionId: edition.id,
                                            productId: edition.productId,
                                            nameProduct: nameProduct,
                                            editionName: edition.name
                                        },
                                        ProductManagementConstant.VERSION_LIST
                                    )
                                }
                            >
                                {trI18n('BUTTON-ADD-VERSION')}
                            </Button>
                        </div>
                        <div
                            className={`version-table ${!checkOpenDropDownVerson(
                                edition.id,
                                openDropDownVersion
                            ) && 'd-none'}`}
                        >
                            <VersionList
                                listVersionData={edition.listVersion}
                                edition={edition}
                                onOpenVersionList={onOpenVersionList}
                                nameProduct={nameProduct}
                                setListVersionUpdated={setListVersionUpdated}
                                setIsEdit={setIsEdit}
                                setListStatusEditionDisabled={setListStatusEditionDisabled}
                                setEditionList={setEditionList}
                                listGptModel={listGptModel}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        className={`${snapshot.isDraggingOver ? 'draggingOver' : ''}`}
                        {...provided.droppableProps}
                    >
                        {editionList?.map((item, index) => (
                            <Draggable key={item.id} draggableId={`${item.id}`} index={index}>
                                {(provided, snapshot) =>
                                    renderLineCreateOrList(provided, snapshot, item, index)
                                }
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>

            {/* dialog delete  */}
            <ConfirmDialog
                isOpen={showPopUpDelete.isOpen}
                msgConfirm={tr(
                    '{{item}}を完全削除します。宜しいでしょうか。'.replace(
                        '{{item}}',
                        ProductManagementConstant.NAME.EDITION
                    )
                )}
                okCallBack={() =>
                    onClickDeleteEditionItem(
                        setEditionList,
                        showPopUpDelete.index,
                        setIsEdit,
                        setShowPopUpDelete
                    )
                }
                closeCallBack={() => setShowPopUpDelete({ isOpen: false })}
                textClose={trI18n('COMBTN007')}
            />
        </DragDropContext>
    );
};

export default ListItemEdition;
